<template>
  <div class="social-login">
    <span class="social-login__headline">
      {{ loginMode === 'login' ? 'Login with your social account' : 'Register with your social account' }}
    </span>
    <ul class="social-login__link-list">
      <li v-if="socialLogins" class="social-login__list-item" v-for="socialLogin in socialLogins" :key="socialLogin.id">
        <a class="social-login__link" :href="socialLogin.url" :title="socialLogin.text">
          <icon-google class="social-login__icon" v-if="socialLogin.id === 'google'" />
          <icon-facebook class="social-login__icon" v-else-if="socialLogin.id === 'facebook'" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import IconGoogle from '~/assets/icons/IconGoogleColoured.svg';
import IconFacebook from '~/assets/icons/IconFacebookColoured.svg';
import { useFetch, useRuntimeConfig, useRoute } from "#imports";

export default {
  async setup () {
    const appConfig = useRuntimeConfig();
    const route = useRoute()

    const returnTo = ['/login/', '/create-account/'].includes(route.path)
      ? '/my-account/'
      : route.path;

    const { data } = await useFetch(`${appConfig.public.baseUrl}/wp-json/content-search/v1/search?type=oauth-init&return-to=${returnTo}`);

    return {
      socialLogins: data ?? [],
    };
  },
  components: {
    IconGoogle,
    IconFacebook,
  },
  props: {
    loginMode: String,
  },
};
</script>

<style lang="scss">
@use "~/common/scss/button";
@use "~/common/scss/helpers";
@use "~/common/scss/variables";

.social-login {
  align-items: center;
  display: flex;
  flex-flow: column;
  padding: 0 0;

  &__headline {
    color: variables.$colorGrey;
    display: block;
    text-transform: uppercase;
    margin: 0 0 .5rem;
    width: 100%;
  }

  &__link-list {
    align-items: center;
    display: flex;
    gap: 1.5rem;
    list-style: none;
    min-height: helpers.px-to-rem(35);
    width: 100%;
  }

  &__list-item {
    flex: 1 1 50%;
  }

  &__link {
    @include button.buttonGreyIcon();
    @include button.buttonMedium(true);

    width: 100%;
  }

  &__icon {
    width: 1.25em;
  }
}
</style>
